import { createAction } from 'redux-actions';
import { instancePayment as instance, createApiActions } from '../api';
// import { Parse } from 'parse/react-native';
import { Parse } from 'parse';
export const actionsCreatePayment = createApiActions('CREATE_PAYMENT');

export const createPayment = createAction(
  'CREATE_PAYMENT',
  (data, callback = () => {}) => ({
    isPromise: true,
    actions: actionsCreatePayment,
    promise: () => instance.post('/mobile/payments', data),
    callback,
  }),
);

export const createPayment2 = createAction(
  'CREATE_PAYMENT',
  (data, callback = () => {}) => ({
    isPromise: true,
    actions: actionsCreatePayment,
    promise: () => instance.post('/widget/payments', data),
    callback,
  }),
);

export const createPayment3 = createAction(
  'CREATE_PAYMENT',
  (params, callback = () => {}) => ({
    isPromise: true,
    actions: actionsCreatePayment,
    promise: () => Parse.Cloud.run('payment', params),
    callback,
  }),
);

export const createPaymentIos = createAction(
    'CREATE_PAYMENT',
    (params, callback = () => {}) => ({
        isPromise: true,
        actions: actionsCreatePayment,
        promise: () => Parse.Cloud.run('addIosPayment', params),
        callback,
    }),
);

export const checkPayment = createAction(
  'CHECK_PAYMENT',
  (params, callback = () => {}) => ({
    isPromise: true,
    actions: actionsCreatePayment,
    promise: () => Parse.Cloud.run('checkPayment', params),
    callback,
  }),
);


